(function () {
    'use strict';

    angular.module('app').factory('FvmScreeningRemarkValidator', FvmScreeningRemarkValidator);

    FvmScreeningRemarkValidator.$inject = [];
    function FvmScreeningRemarkValidator() {

        const remarkArrayMap = {
            'identity': 'IdentityRemarks',
            'activity': 'ActivityRemarks',
            'justification': 'JustificationRemarks',
            'persons': 'PersonRemarks',
            'relations': 'RelationsRemarks',
        };

        /**
         * Validate the screeningRemarksObject 
         * { 
         *      IdentityRemarks: Array,
         *      ActivityRemarks: Array,
         *      PersonRemarks: Array,
         *      JustificationRemarks: Array,
         *      RelationsRemarks: Array,
         * }
         **/
        return {
            OrganisationHasIndeterminateRemarks: organisationHasIndeterminateRemarks,
            OrganisationHasInvalidRemarks: organisationHasInvalidRemarks,
            OrganisationHasInvalidRemarksWithoutReason: organisationHasInvalidRemarksWithoutReason,
            OrganisationRequestSectionInvalidated: organisationRequestSectionInvalidated,
        };

        function organisationRequestSectionInvalidated(remarkObject, section) {
            if (!remarkObject || !section) return false;

            const normalizedSection = section.toLowerCase();

            const sectionRemarksKey = remarkArrayMap[normalizedSection];

            if (!sectionRemarksKey)
                return false;

            const sectionRemarks = remarkObject[sectionRemarksKey];

            return arrayHasInvalidRemarks(sectionRemarks);
        }

        function organisationHasIndeterminateRemarks(remarkObject, partnerToValidate) {
            return checkAllRemarks(remarkObject, partnerToValidate, arrayHasIndeterminateRemarks);
        }

        function organisationHasInvalidRemarks(remarkObject, partnerToValidate) {
            return checkAllRemarks(remarkObject, partnerToValidate, arrayHasInvalidRemarksByPartner);
        }

        function organisationHasInvalidRemarksWithoutReason(remarkObject, partnerToValidate) {
            return checkAllRemarks(remarkObject, partnerToValidate, arrayHasInvalidRemarksWithoutReason);
        }

        function checkAllRemarks(remarkObject, partnerToValidate, validationFunction) {
            if (!remarkObject)
                return false;

            for (const [ , remarks] of Object.entries(remarkObject))
                if (validationFunction(remarks, partnerToValidate))
                    return true;

            return false;
        }

        function arrayHasInvalidRemarksWithoutReason(remarks, partnerToValidate) {
            if (!remarks)
                return false;
            return remarks.some(r => r.Partner === partnerToValidate && r.IsValid === false && !r.Description);
        }

        function arrayHasInvalidRemarksByPartner(remarks, partnerToValidate) {
            if (!remarks)
                return false;
            return remarks.some(r => r.Partner === partnerToValidate && r.IsValid === false && r.Description && r.Description.length > 0);
        }

        function arrayHasInvalidRemarks(remarks) {
            if (!remarks)
                return false;
            return remarks.some(r => r.IsValid === false);
        }

        function arrayHasIndeterminateRemarks(remarks, partnerToValidate) {
            if (!remarks)
                return;
            return remarks.some(r => r.Partner === partnerToValidate && r.IsValid === null);
        }
    }
})();
